import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseEntity from "./BaseEntity";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";

@inheritSerialization(BaseEntity)
export default class Persyaratan extends BaseEntity {

	@serialize
	@deserialize
	public nama: string = "";

	@serialize
	@deserialize
	public tahun: string = "";

	@serialize
	@deserialize
	public pendidikan: string = "";

	@serialize
	@deserialize
	public count: number = 0;

	public checked: boolean = false;

	public file: any = null;

	public fileFeedback() {
		return this.defaultPropertyFeedback('file', Boolean(this.file));
	}

	public countFeedback() {
		return this.defaultPropertyFeedback('count');
	}

	public namaFeedback() {
		return this.defaultPropertyFeedback('nama');
	}

	public tahunFeedback() {
		return this.defaultPropertyFeedback('tahun');
	}

	public pendidikanFeedback() {
		return this.defaultPropertyFeedback('pendidikan');
	}
	public table() {
		const {
			nama, tahun, pendidikan, count:jumlah
		} = this;
		return {
			nama, tahun, pendidikan, jumlah
		};
	}

	public static columnName(): Array<TableColumn> {
		const table = new Persyaratan().table();
		let keys = Object.keys(table);

		return keys.map((field: any) => {
			const tableColumn = new TableColumn();
			tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

			return tableColumn;
		});
	}
}
